import { Component, OnInit, ElementRef } from '@angular/core';

import { Auth } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { ReportService } from '../services/reports/report.service';
import { ProviderService } from '../services/providers/provider.service';
import { DoctorService }  from '../services/doctors/doctor.service';

import { ResponseContentType } from '@angular/http';

import { saveAs } from 'file-saver';

import * as _ from 'lodash';
import { map } from 'rxjs/operator/map';

@Component({
  selector: 'reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  fromDate: Date;
  toDate: Date;
  fromDatePatientBySeller: Date;
  toDatePatientBySeller: Date;

  fromReportsDate: Date;
  toReportsDate: Date;

  fromBillingDate: Date;
  toBillingDate: Date;

  fromDateLoginsByProvider: Date;
  toDateLoginsByProvider: Date;

  allReports: any[] = []
  reportsForHtml = []
  defaultReports = []
  defaultReportsForHtml

  providers = []
  providersByCall = []
  providersByBillingCall = []
  providersPatientsBySeller = []
  providersLoginsByProvider = []
  selectedProvider: any = { name: "All", id:0 }

  doctorsByBillingCall = []

  availableReports = []
  loading:boolean=false

  showingAll:boolean=true

  billingIncludeNotBillable:boolean=false
  prescriptionInfo:boolean=false
  onlyWithPrescriptions:boolean=false
  lean:boolean=false
  oldMethod:boolean = true;
  hasReportsPermission:boolean = false;

  constructor(private elementRef: ElementRef,
    protected requestService: RequestService,
    protected reportService: ReportService,
    protected providerService: ProviderService,
    protected doctorService: DoctorService,
    protected auth: Auth) {
  }

  ngOnInit() {
    this.loading=true
    this.hasReportsPermission = this.auth.hasReportsPermission();
    this.providerService.get().then((response) => {
      this.providers = response
      this.providersByCall = _.cloneDeep(this.providers)
      this.providersPatientsBySeller = _.cloneDeep(this.providers)
      this.providersByBillingCall = _.cloneDeep(this.providers)
      this.providersLoginsByProvider = _.cloneDeep(this.providers)
    })
    this.doctorService. getAll().then(doctors => {
      this.doctorsByBillingCall = doctors;
    })
   this.getDefaultReports({})
  }

  getDefaultReports(params){
    this.reportService.getDefaultReports(params).then((response)=>{
      this.defaultReports = response
      this.prepareDefaultReports(response)
    })
  }

  /**
   *
   * @param response : array with default reports
   * report : {
   *  name,
   *  description,
   *  result:{
   *      key:value,
   *      key2:value
   *      }
   *  }
   */
  prepareDefaultReports(response){
    this.defaultReportsForHtml = response.map((report)=>{
      let columns = []
      for (let key in report.result){
        columns.push({
          col1:key,
          col2:report.result[key]
        })
      }
      report["columns"]=columns
      return report
    })
    this.loading=false
  }

  selectProvider(provider) {
    this.selectedProvider = provider
    this.providerService.getReports(provider.id).then((response) => {
      this.availableReports = response
      this.reportsForHtml = []
    })
  }

  loadReports() {
    console.log(this.fromReportsDate)
    if (!this.fromReportsDate || !this.toReportsDate) return
    this.allReports = []
    let promises = []

    let params = {
      from: this.getDate(this.fromReportsDate),
        to: this.getDate(this.toReportsDate)
    }

    if (this.selectedProvider.id != 0) params["providerId"]=this.selectedProvider.id

    this.getDefaultReports(params)
    this.availableReports.forEach(element => {
      promises.push(this.providerService.getOneReport(this.selectedProvider.id, element.id, {
        from: this.getDate(this.fromReportsDate),
        to: this.getDate(this.toReportsDate)
      }))
    });
    if (promises.length>0){
      Promise.all(promises).then((response) => {
        this.prepareReports(response)
        this.showingAll=false
      })
    }
  }

  prepareReports(response){
    let array = []
    for (let i = 0; i < response.length; i++) {
      _.each(response[i], (col2, col1) => {
        array.push({ col1: col1, col2: col2 });
      });
      let description = this.availableReports[i].description
      let descriptionWords = description.split(" ")
      this.allReports.push({
        array: array.slice(),
        description: description, //Affiliates per province
        info: descriptionWords[0], //Province
        from: descriptionWords[descriptionWords.length-1] //Affiliates
      })
      array = []
    }
    console.log(this.allReports)
    this.prepareArraysToHtml()
  }

  prepareArraysToHtml() {
    let reportsForShow = []
    let twoReports = [this.allReports[0]]
    for (let i = 1; i < this.allReports.length; i++) {
      if (i % 2 == 0) {
        reportsForShow.push(twoReports.slice())
        twoReports = []
      }
      twoReports.push(this.allReports[i])
    }
    if (twoReports.length != 0) reportsForShow.push(twoReports.slice())
    console.log(reportsForShow)
    this.reportsForHtml = reportsForShow.slice()
  }

  allProviderCalls(checked){
    this.providersByCall.forEach(provider=>provider.selected=checked)
  }

  allProviderBillingCalls(checked){
    this.providersByBillingCall.forEach(provider=>provider.selected=checked)
  }

  allProviderPatientBySeller(checked){
    this.providersPatientsBySeller.forEach(provider=>provider.selected=checked)
  }

  allProviderLoginsByProvider(checked){
    this.providersLoginsByProvider.forEach(provider=>provider.selected=checked)
  }
  sendBilling() {
    let selectedProviders = this.providersByBillingCall.filter(provider => provider.selected == true).map(provider => provider.id)
    let selectedDoctors = this.doctorsByBillingCall.filter(doctor => doctor.selected == true).map(doctor => doctor.id)
    var requestParams = {
      method: 'get',
      urlKey: 'billingCallsReport',
      urlQueryParams: {
        from: this.getDate(this.fromBillingDate),
        to: this.getDate(this.toBillingDate),
        providers: selectedProviders,
        doctors: selectedDoctors,
        onlyBillable: !this.billingIncludeNotBillable,
        prescriptionInfo: this.prescriptionInfo,
        onlyWithPrescriptions: this.onlyWithPrescriptions,
        lean: this.lean,
        oldMethod: this.oldMethod
      },
      asObservable: true,
      responseType: ResponseContentType.Blob
    }

    this.requestService.makeRequest(requestParams).subscribe(
      (response) => {
        var headers = response.headers;
        var blob = new Blob([response._body], { type: headers.get('Content-type') });
        var filename = 'calls.xlsx';
        //saveAs(blob, filename);
        alert("Report being proccesed, email will be sent afterwards")
      });

  }
  sendPatientBySeller() {
    let selectedProviders = this.providersPatientsBySeller.filter(provider => provider.selected == true).map(provider => provider.id)
    var requestParams = {
      method: 'get',
      urlKey: 'patientCreatedBySellerReport',
      urlQueryParams: {
        from: this.getDate(this.fromDatePatientBySeller),
        to: this.getDate(this.toDatePatientBySeller),
        providers: selectedProviders
      },
      asObservable: true,
      responseType: ResponseContentType.Blob
    }

    this.requestService.makeRequest(requestParams).subscribe(
      (response) => {
        var headers = response.headers;
        var blob = new Blob([response._body], { type: headers.get('Content-type') });
        var filename = 'patient-by-seller.xlsx';
        //saveAs(blob, filename);
        alert("Report being proccesed, email will be sent afterwards")
      });

  }
  sendLoginsByProvider() {
    let selectedProviders = this.providersLoginsByProvider.filter(provider => provider.selected == true).map(provider => provider.id)
    var requestParams = {
      method: 'get',
      urlKey: 'loginsReport',
      urlQueryParams: {
        from: this.getDate(this.fromDateLoginsByProvider),
        to: this.getDate(this.toDateLoginsByProvider),
        providers: selectedProviders
      },
      asObservable: true,
      responseType: ResponseContentType.Blob
    }

    this.requestService.makeRequest(requestParams).subscribe(
      (response) => {
        alert("Report being proccesed, email will be sent afterwards")
      });

  }
  getDate(date: Date): string {
    let dateParts: number[] = []
    let fecha: string = '';
    let i;
    for (i = 0; i < 10; i++) {
      if (date[i] == '-') {
        dateParts.push(Number(fecha))
        fecha = '';
      }
      else fecha += date[i]
    }
    dateParts.push(Number(fecha))

    let day = dateParts[2].toString()
    let month = dateParts[1].toString()
    if (day.length == 1) day = '0' + day;
    if (month.length == 1) month = '0' + month;
    return day + '-' + month + '-' + dateParts[0]
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts